import util from 'util';
import { getStaticLocale } from '@/utils/locale';
export function formatNumber(num) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var retain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (!num) {
    return num;
  }

  num = +num;
  var paramNum = num;
  num = Math.abs(num);
  var val = 10000;

  if (type === 'gradient') {
    // 图表axis展示逻辑
    val = 1000;
  }

  var res = num;

  if (num >= val && num < 1000000) {
    res = "".concat((num / 1000).toFixed(retain), "k");
  } else if (num >= 1000000) {
    res = "".concat((num / 1000000).toFixed(retain), "m");
  }

  if (getStaticLocale() === 'pt') {
    res = res.toString().split('.').join(',');
  }

  if (paramNum < 0) {
    res = "-".concat(res);
  }

  return res;
}
/** 只保留整数 */

export function formatNumberForReservedInt(num) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return formatNumber(num, type, 0);
}
export var formatIfEmpty = function formatIfEmpty(val) {
  if (val === undefined || val === null) {
    return '--';
  }

  return formatNumber(val);
};
/**
 * 自定义格式化函数, 为什么要自定义？因为有时候字符串里的替换符是%s, 有的时候是${0}, ${0}, 在此统一处理一下
 *
 * @param      {Array}   args[0]: 要格式化的字符串， args[1] ... args[n] 待替换的变量
 * @return     {string}  { 格式化后的字符串 }
 */

export function formatPlaceholder() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var targetStr = args[0];

  if (!targetStr) {
    return '';
  }

  if (targetStr.includes('%s')) {
    targetStr = util.format.apply(null, args);
  }

  for (var i = 1; i < args.length; i++) {
    var replacement = "${".concat(i - 1, "}");
    var replacementRTL = "{".concat(i - 1, "}$");

    if (targetStr.includes(replacement) || targetStr.includes(replacementRTL)) {
      // args[1] 对应的是 ${0}, args[2] 对应的是 ${1}, 依次类推
      // 把所有${0}全部替换为args[1]，依次类推
      targetStr = targetStr.split(replacement).join(args[i]).split(replacementRTL).join(args[i]);
    }
  }

  return targetStr;
}
/**
 * [{key:1,value:2},{key:2,value:3}] --> [{x:1,y:2},{x:2,y:3}]
 *
 * @param     data:数据，x:data中的哪个key作为x轴，y:data中的哪个key作为y轴
 * @return
 */

export var formatForLineChart = function formatForLineChart(data) {
  var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'key';
  var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
  var result = data.map(function (val) {
    return {
      x: val[x],
      y: val[y]
    };
  });
  return result;
};
/**
 * [{key:1,value:2},{key:2,value:3}] --> [{key:'1',percent:2},{key:'2',percent:3}]
 *
 * @param     data:数据，x:data中的哪个key作为x轴，y:data中的哪个key作为y轴
 * @return
 */

export var formatForPieChart = function formatForPieChart(data) {
  var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'key';
  var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
  var result = data.map(function (val) {
    return {
      key: val[x].toString(),
      percent: val[y]
    };
  });
  return result;
};
/** '0.23'|0.23 --> 23% */

export var formatPercent = function formatPercent(point) {
  if (typeof point === 'string') {
    if (point.indexOf('%') !== -1) {
      return point;
    }

    return "".concat((Number(point) * 100).toFixed(0), "%");
  }

  return "".concat((point * 100).toFixed(0), "%");
};
export var formatPrice = function formatPrice(num) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!num) {
    return num;
  }

  return formatNumber(Number(num) / 100, type, 2);
}; // 结算模块的,就不管怎样小数也向下取整

export function formatForSettle(num) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var retain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (!num) {
    return num;
  }

  num = +num;
  var paramNum = num;
  num = Math.abs(num);
  num = Math.floor(num);
  var val = 10000;

  if (type === 'gradient') {
    // 图表axis展示逻辑
    val = 1000;
  }

  var res = num;

  if (num >= val && num < 1000000) {
    var parse = Math.floor(num / 1000 * Math.pow(10, retain)) / Math.pow(10, retain);
    res = "".concat(parse.toFixed(retain), "k");
  } else if (num >= 1000000) {
    var _parse = Math.floor(num / 1000000 * Math.pow(10, retain)) / Math.pow(10, retain);

    res = "".concat(_parse.toFixed(retain), "m");
  }

  if (getStaticLocale() === 'pt') {
    res = res.toString().split('.').join(',');
  }

  if (paramNum < 0) {
    res = "-".concat(res);
  }

  return res;
}
/** 91天以上，变成90+ */

export function formatDayNumber(num) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (num && Number(num) > 90) {
    return '90+';
  }

  return formatNumber(num, type, 0);
}

var isChina = function isChina(str) {
  var pattern = new RegExp("[\u4E00-\u9FA5]+");
  return pattern.test(str);
}; // 有时候没法css处理省略号，用这个


export var formatellipsis = function formatellipsis(name) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 11;

  if (!name) {
    return '';
  }

  var length = 0;
  var sliceEnd = 0;

  for (var i = 0; i < name.length; i++) {
    if (/[A-Z]/.test(name[i])) {
      length += 1.5;
    } else if (isChina(name[i])) {
      length += 2;
    } else {
      length += 1;
    }

    if (length > maxLength) {
      sliceEnd = i;
      break;
    }
  }

  if (length > maxLength) {
    return "".concat(name.slice(0, sliceEnd), "...");
  }

  return name;
};